import store from './index';
export default {
  store,
  install(Vue) {
    var vueInstance = Vue;
    vueInstance.prototype.$store = store();
  }
};